import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace AKCHerding {
  const stockOnlyOptions = [
    { value: "None", id: "None" },
    { value: Constants.dog_class_section.sheep, id: Constants.dog_class_section.sheep },
    { value: Constants.dog_class_section.cattle, id: Constants.dog_class_section.cattle },
    { value: Constants.dog_class_section.ducks, id: Constants.dog_class_section.ducks },
  ];

  const getStockOnlyForm = (showType: string): IEventRegisterRow[] => ([
    {
      allowDuplicates: true,
      inputs: [{
        elementType: "level",
        type: "dropdown",
        flex: 2,
        label: showType,
        options: stockOnlyOptions,
      }]
    },
  ]);

  export const form: IEventRegisterRow[] = [
    {
      allowDuplicates: true,
      inputs: [{
        elementType: "level",
        type: "dropdown",
        flex: 2,
        label: Constants.dog_class_element.course_a,
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_element_level.started, id: Constants.dog_class_element_level.started },
          { value: Constants.dog_class_element_level.intermediate, id: Constants.dog_class_element_level.intermediate },
          { value: Constants.dog_class_element_level.advance, id: Constants.dog_class_element_level.advance },
        ]
      },
      {
        elementType: "section",
        showElement: Constants.dog_class_element.course_a,
        type: "dropdown",
        defaultValue: "None",
        label: "Section",
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_section.sheep, id: Constants.dog_class_section.sheep },
          { value: Constants.dog_class_section.cattle, id: Constants.dog_class_section.cattle },
          { value: Constants.dog_class_section.ducks, id: Constants.dog_class_section.ducks },
        ]
      }]
    },
    {
      allowDuplicates: true,
      inputs: [{
        elementType: "level",
        type: "dropdown",
        flex: 2,
        label: Constants.dog_class_element.course_b,
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_element_level.started, id: Constants.dog_class_element_level.started },
          { value: Constants.dog_class_element_level.intermediate, id: Constants.dog_class_element_level.intermediate },
          { value: Constants.dog_class_element_level.advance, id: Constants.dog_class_element_level.advance },
        ]
      },
      {
        elementType: "section",
        showElement: Constants.dog_class_element.course_b,
        type: "dropdown",
        defaultValue: "None",
        label: "Section",
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_section.sheep, id: Constants.dog_class_section.sheep },
          { value: Constants.dog_class_section.cattle, id: Constants.dog_class_section.cattle },
          { value: Constants.dog_class_section.ducks, id: Constants.dog_class_section.ducks },
        ]
      }]
    },
    {
      allowDuplicates: true,
      inputs: [{
        elementType: "level",
        type: "dropdown",
        flex: 2,
        label: Constants.dog_class_element.course_c,
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_element_level.started, id: Constants.dog_class_element_level.started },
          { value: Constants.dog_class_element_level.intermediate, id: Constants.dog_class_element_level.intermediate },
          { value: Constants.dog_class_element_level.advance, id: Constants.dog_class_element_level.advance },
        ]
      },
      {
        elementType: "section",
        showElement: Constants.dog_class_element.course_c,
        type: "dropdown",
        defaultValue: "None",
        label: "Section",
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_section.sheep, id: Constants.dog_class_section.sheep },
          { value: Constants.dog_class_section.cattle, id: Constants.dog_class_section.cattle },
          { value: Constants.dog_class_section.ducks, id: Constants.dog_class_section.ducks },
        ]
      }]
    },
    {
      allowDuplicates: true,
      inputs: [{
        elementType: "level",
        type: "dropdown",
        flex: 2,
        label: Constants.dog_class_element.course_d,
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_element_level.started, id: Constants.dog_class_element_level.started },
          { value: Constants.dog_class_element_level.intermediate, id: Constants.dog_class_element_level.intermediate },
          { value: Constants.dog_class_element_level.advance, id: Constants.dog_class_element_level.advance },
        ]
      },
      {
        elementType: "section",
        showElement: Constants.dog_class_element.course_d,
        type: "dropdown",
        defaultValue: "None",
        label: "Section",
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_section.sheep, id: Constants.dog_class_section.sheep },
          { value: Constants.dog_class_section.cattle, id: Constants.dog_class_section.cattle },
          { value: Constants.dog_class_section.ducks, id: Constants.dog_class_section.ducks },
        ]
      }]
    },
  ];

  export const getForm = (showType: string): IEventRegisterRow[] => {
    if (
      showType === Constants.show_type.pre_trial_herding ||
      showType === Constants.show_type.instinct_test_herding
    ) {
      return getStockOnlyForm(showType);
    }

    return form;
  };
}